export default {
  CREATED: 'Created',
  PLANNED: 'Planned',
  APPROVED: 'Approved',
  DONE: 'Done',
  CANCELED: 'Canceled',
  REFUND: 'Refund'
}
